import React from 'react';
import { Dialog } from '@material-ui/core';
import YFinput from '../../form/elements/YFInput';
import YFTextArea from '../../form/elements/YFTextArea';
import { Row, Col, message } from 'antd';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useSyncCall } from '../../api/apiCallHook';
import { submitEnquiry } from '../../api';

const EnquiryDialog = ({ history, open, handleClose }) => {
    const { register, handleSubmit, errors } = useForm();

    const request = useSyncCall(submitEnquiry);

    const submit = async (data) => {
        data.member_type = 'individual';
        data.history = history();
        const response = await request({ request: data });
        handleClose(false);
        message.success(response.message);
    };

    return (
        <Dialog
            fullWidth={true}
            maxWidth="sm"
            open={open}
            onBackdropClick={() => handleClose(false)}
            className="enquiryDialogContainer"
        >
            <h2 className="enquiryDialogTitle">Enquiry Form</h2>
            <form test_id="enquiry_form" onSubmit={handleSubmit(submit)} className="solutionForBusinessFormContainer">
                <Row>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="enquiry_form_name"
                            name="name"
                            type="text"
                            label="Full Name"
                            placeholder="Enter Full Name"
                            register={register({
                                required: true,
                            })}
                        />
                        <div className="form-error">
                            {errors.name && <span className="formFieldError">Please enter your name.</span>}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="enquiry_form_email"
                            name="email"
                            type="text"
                            label="Email"
                            placeholder="Enter your email"
                            register={register({
                                required: 'Please enter your email.',
                                pattern: {
                                    value: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: 'Invalid email address',
                                },
                            })}
                        />
                        <div className="form-error">
                            {errors.email && <p className="formFieldError">{errors.email.message}</p>}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="enquiry_form_contact_number"
                            name="contact_number"
                            type="number"
                            min="0"
                            step="0"
                            label="Phone"
                            placeholder="Enter your phone number"
                            register={register({
                                required: true,
                                pattern: {
                                    value: '[0-9]*',
                                    message: 'Invalid email address',
                                },
                            })}
                        />
                        <div className="form-error">
                            {errors.contact_number && <p className="formFieldError">Please enter your phone number.</p>}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container-element"
                    >
                        <YFTextArea
                            test_id="enquiry_form_message"
                            name="message"
                            type="text"
                            label="Message"
                            placeholder="Enter your Message"
                            register={register({
                                required: false,
                            })}
                        />
                        <div className="form-error">
                            {errors.address && <span className="formFieldError">Please enter your message.</span>}
                        </div>
                    </Col>
                </Row>
                <input test_id="enquiry_form_submit" type="submit" label="Submit" />
            </form>
        </Dialog>
    );
};

EnquiryDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    history: PropTypes.func.isRequired,
};

export default EnquiryDialog;
